import React, { useState, useEffect } from 'react'
import { Box, Button, Select, MenuItem, Typography, TextField } from '@mui/material'

const OptimizacionSection = ({
  nivelServicio,
  setNivelServicio,
  mesLlegada,
  setMesLlegada,
  cargabilidad,
  disableOptimizarInventario = false,
  onOptimizar,
  onActualizarCargabilidad,
  readOnly = false,
}) => {
  const [cargabilidadEditable, setCargabilidadEditable] = useState('')

  // Sincronizar el valor editable con la prop cargabilidad cuando cambie
  useEffect(() => {
    if (cargabilidad !== undefined && cargabilidad !== null && cargabilidad !== '') {
      setCargabilidadEditable(cargabilidad.toString())
    } else {
      setCargabilidadEditable('')
    }
  }, [cargabilidad])


  // Generar opciones de fechas (12 meses antes y 12 después)
  const generarOpcionesFechas = () => {
    const opciones = []
    const fechaActual = new Date()

    for (let i = 0; i <= 12; i += 1) {
      const fecha = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth() + i,
        10,
      )
      const año = fecha.getFullYear()
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0')
      const dia = '10'
      const fechaFormateada = `${año}-${mes}-${dia}`
      opciones.push(fechaFormateada)
    }
    return opciones
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Button
        variant="contained"
        onClick={onOptimizar}
        disabled={disableOptimizarInventario || readOnly}
        sx={{
          backgroundColor: '#4c75aa',
          color: 'white',
          fontWeight: 'bold',
          padding: '10px 20px',
          '&:hover': {
            backgroundColor: '#5F9EA0',
          },
          '&.Mui-disabled': {
            backgroundColor: '#bdbdbd',
            color: '#f5f5f5',
          },
        }}
      >
        Optimizar días inventario
      </Button>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 'bold', minWidth: '120px' }}
        >
          Dias inventario
        </Typography>
        <TextField
          type="number"
          value={nivelServicio !== undefined && nivelServicio !== null && nivelServicio !== '' ? parseInt(nivelServicio, 10) : ''}
          onChange={(e) => {
            const {value} = e.target;
            // Solo permitir números enteros
            const intValue = value === '' ? '' : parseInt(value, 10);
            setNivelServicio(intValue);
          }}
          disabled={readOnly}
          size="small"
          placeholder="Ingrese número"
          inputProps={{
            min: 1,
            step: 1,
            style: {
              textAlign: 'center',
              backgroundColor: '#ffb6c1b5',
              borderRadius: '4px',
              fontWeight: 'bold',
            }
          }}
          sx={{
            width: '120px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'transparent',
              },
            },
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 'bold', minWidth: '80px' }}
        >
          Mes llegada
        </Typography>
        <Select
          value={mesLlegada || ''}
          onChange={(e) => setMesLlegada(e.target.value)}
          disabled={readOnly}
          size="small"
          displayEmpty
          renderValue={(selected) => {
            if (!selected) return <em>Seleccionar...</em>
            return selected.substring(0, 7)
          }}
          sx={{
            width: '120px',
            '& .MuiSelect-select': {
              textAlign: 'center',
              backgroundColor: '#e6e6fab0',
              borderRadius: '4px',
              fontWeight: 'bold',
            },
          }}
        >
          <MenuItem value="">
            <em>Seleccionar...</em>
          </MenuItem>
          {generarOpcionesFechas().map((opcion) => (
            <MenuItem key={opcion} value={opcion}>
              {opcion.substring(0, 7)}
            </MenuItem>
          ))}
        </Select>
        {cargabilidad !== undefined && cargabilidad !== null && cargabilidad !== '' && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
            <Typography
              variant="body2"
              sx={{ 
                fontWeight: 'bold', 
                color: '#666',
                fontSize: '0.875rem',
                minWidth: '90px'
              }}
            >
              Cargabilidad:
            </Typography>
            <TextField
              type="number"
              value={cargabilidadEditable}
              onChange={(e) => {
                const { value } = e.target
                // Solo permitir números enteros
                const intValue = value === '' ? '' : parseInt(value, 10)
                setCargabilidadEditable(intValue === '' ? '' : intValue.toString())
              }}
              disabled={readOnly}
              size="small"
              placeholder="Cargabilidad"
              inputProps={{
                min: 1,
                step: 1,
                style: {
                  textAlign: 'center',
                  backgroundColor: '#fff9c4b5',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                }
              }}
              sx={{
                width: '80px',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#ddd',
                  },
                },
              }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                if (cargabilidadEditable && onActualizarCargabilidad) {
                  onActualizarCargabilidad(parseInt(cargabilidadEditable, 10))
                }
              }}
              disabled={readOnly || !cargabilidadEditable || cargabilidadEditable === cargabilidad?.toString()}
              sx={{
                backgroundColor: '#9fa8da',
                color: 'white',
                fontSize: '0.75rem',
                padding: '4px 12px',
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: '#7986cb',
                },
                '&:disabled': {
                  backgroundColor: '#e0e0e0',
                  color: '#9e9e9e',
                },
              }}
            >
              Cambiar
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default OptimizacionSection 